import { TailwindClasses } from '@ngg/storefront-utils';
import { ComponentPropsWithoutRef, ReactNode } from 'react';

export const HeartIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="11" y="20" width="2" height="0.5" fill="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.05179 8.00958C4.24268 7.033 5.15704 5.68942 6.41311 5.19512C7.00321 4.96289 7.68203 4.91077 8.45048 5.18899C9.14507 5.44047 9.96323 5.98119 10.8609 7.00001H11.6797H11.7531H11.7576H12H12.1951H12.2469H12.2578H13.1391C14.0368 5.98119 14.8549 5.44047 15.5495 5.18899C16.318 4.91077 16.9968 4.96289 17.5869 5.19512C18.8429 5.68942 19.7573 7.033 19.9482 8.00958C20.2382 9.49312 19.2208 10.6734 18.7262 11.1795L18.7149 11.1911L18.704 11.2029L12 18.5198L5.29595 11.2029L5.28507 11.1911L5.27381 11.1795C4.77914 10.6734 3.76181 9.49312 4.05179 8.00958ZM12 20.1644L12.0918 20.0841L12.0921 20.0844L12 20.1996L11.9078 20.0844L11.9082 20.0841L12 20.1644ZM3.83204 12.5657L9.98145 19.2772L11.3597 21H12.6403L14.0185 19.2772L20.1679 12.5657C20.6804 12.0403 22.411 10.1837 21.911 7.6259C21.6058 6.06451 20.2878 4.10873 18.3193 3.33404C17.2971 2.93178 16.1156 2.857 14.8687 3.30845C13.9058 3.65704 12.9449 4.30387 12 5.28515C11.0551 4.30387 10.0942 3.65704 9.13133 3.30845C7.88442 2.857 6.7029 2.93178 5.68071 3.33404C3.71218 4.10873 2.39414 6.06451 2.08894 7.6259C1.58897 10.1837 3.31962 12.0403 3.83204 12.5657Z"
      fill="black"
    />
    <path d="M12.6667 7.2H11.3333L11.25 7H12.75L12.6667 7.2Z" stroke="black" />
  </svg>
);

export const UserIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="7" r="4" stroke="black" strokeWidth="2" />
    <path d="M4 22V17L8 14H16L20 17V22" stroke="black" strokeWidth="2" />
  </svg>
);

export const CartIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="8" width="18" height="13" stroke="black" strokeWidth="2" />
    <rect
      x="1"
      y="-1"
      width="10"
      height="5"
      transform="matrix(1 0 0 -1 6 7)"
      stroke="black"
      strokeWidth="2"
    />
  </svg>
);

export const StockStatusGreen = ({
  className,
}: {
  className: TailwindClasses;
}) => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className as string}>
    <circle cx="4" cy="4" r="4" fill="#009A44" />
  </svg>
);

export const DiscountIcon = (props: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.04 6.1C1.36 6.1 2.33699e-09 4.73997 2.33699e-09 3.06C-6.50977e-05 1.36 1.35997 0 3.04 0C4.72003 0 6.08 1.36003 6.08 3.04C6.09999 4.72 4.72003 6.1 3.04 6.1ZM3.04 1.52C2.20003 1.52 1.52002 2.20002 1.52002 3.03998C1.52002 3.87995 2.20003 4.55997 3.04 4.55997C3.87997 4.55997 4.55998 3.87995 4.55998 3.03998C4.55998 2.20002 3.87997 1.52 3.04 1.52Z"
        fill="currentColor"
      />
      <path
        d="M10.4795 13.9999C8.79945 13.9999 7.43945 12.6399 7.43945 10.9599C7.43945 9.27992 8.79949 7.91992 10.4795 7.91992C12.1595 7.91992 13.5195 9.27995 13.5195 10.9599C13.5195 12.6399 12.1595 13.9999 10.4795 13.9999ZM10.4795 9.41992C9.63949 9.41992 8.95947 10.0999 8.95947 10.9399C8.95947 11.7799 9.63949 12.4599 10.4795 12.4599C11.3194 12.4599 11.9994 11.7799 11.9994 10.9399C11.9994 10.1199 11.3195 9.41992 10.4795 9.41992Z"
        fill="currentColor"
      />
      <path
        d="M1.81836 13.0314L10.4494 0.108398L11.7134 0.952599L3.08243 13.8756L1.81836 13.0314Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const PackageIcon = (props: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M7.65142 0.175811L13.3511 3.51754C13.7536 3.75014 14.0018 4.18502 14 4.65529V11.3408C14.0025 11.8262 13.7368 12.2725 13.3126 12.4956L10.4962 14.146L7.64629 15.8184C7.24628 16.0605 6.7486 16.0605 6.34859 15.8184L0.648884 12.4715C0.247633 12.2382 2.70237e-05 11.8046 2.70237e-05 11.3356V4.65511C-0.00308355 4.16841 0.26255 3.72026 0.687451 3.49523L3.50871 1.84797L6.35863 0.178723C6.75927 -0.0595745 7.2557 -0.0595745 7.65633 0.178723L7.65142 0.175811ZM10.0354 3.20793L5.34151 6.04925L7.1755 7.08335L11.8694 4.29017L10.0354 3.20793ZM4.79167 7.35697V9.52191C4.79167 9.91379 4.47876 10.2317 4.09243 10.2317C3.70609 10.2317 3.39318 9.91381 3.39318 9.52191V6.57204L1.40378 5.45451V11.2812L6.30521 14.1547V8.20549L4.79167 7.35697ZM3.93504 5.26041L8.65372 2.40021L7.00275 1.42933L4.20631 3.07147L2.16276 4.26358L3.93504 5.26041ZM12.6016 5.49365L7.78895 8.35317C7.76095 8.37276 7.73109 8.38983 7.69999 8.40437V14.1544L9.79901 12.9231L12.6017 11.281L12.6016 5.49365Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ReturnIcon = (props: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M11.6273 9.78298V2.83298C11.6273 2.64068 11.5509 2.45627 11.4149 2.3203C11.279 2.18439 11.0946 2.10798 10.9023 2.10798H2.47732L3.45234 1.15794C3.59085 0.971906 3.63203 0.730775 3.56302 0.509337C3.49401 0.287899 3.32319 0.112774 3.10354 0.038316C2.88381 -0.0360653 2.64179 -0.00090903 2.45233 0.132962L0.202335 2.30796V2.30804C0.138695 2.3729 0.0878329 2.44924 0.0523517 2.53298V2.58303C0.0237871 2.65489 0.0069411 2.73082 0.00238485 2.80805C-0.0144608 3.01174 0.0585366 3.21267 0.202337 3.35801L2.45234 5.60801C2.63691 5.78371 2.90009 5.84972 3.14569 5.78175C3.3913 5.7138 3.58311 5.5219 3.65107 5.27629C3.71902 5.03077 3.6531 4.7675 3.47732 4.58302L2.40228 3.50798H10.1773V9.08298H0.677279C0.454049 9.12497 0.263383 9.26918 0.162216 9.47255C0.06106 9.67591 0.06106 9.915 0.162216 10.1184C0.263372 10.3217 0.454049 10.466 0.677279 10.5079H10.9023C11.0946 10.5079 11.279 10.4316 11.4149 10.2956C11.5509 10.1596 11.6273 9.97523 11.6273 9.78294L11.6273 9.78298Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const TagIcon = (props: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M7.40503 0.23703C7.25206 0.0840504 7.04675 -0.000489075 6.8374 -0.000489094C6.78909 -0.000489098 6.74078 0.00353731 6.69247 0.0115882L1.58774 0.937512C1.25762 0.997899 0.999974 1.25555 0.939598 1.58566L0.0136727 6.69038C-0.0346366 6.95205 0.0499046 7.21776 0.235097 7.40294L8.72534 15.8973C9.03935 16.2113 9.55063 16.2113 9.86463 15.8973L15.8954 9.86659C16.2094 9.55258 16.2094 9.0413 15.8954 8.72729L7.40503 0.23703ZM9.29309 14.1864L1.67216 6.56542L2.42095 2.42276L6.56362 1.67396L14.1846 9.29489L9.29309 14.1864Z"
        fill="currentColor"
      />
      <path
        d="M5.39923 4.23925C5.28651 3.64747 4.56187 3.38982 4.09891 3.77629C3.57555 4.20705 3.78892 5.05648 4.45318 5.18935C5.0047 5.30207 5.51598 4.7908 5.39923 4.23927L5.39923 4.23925Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ChevronIcon = (props: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg
      width="5"
      height="8"
      viewBox="0 0 5 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.31897 3.77L0 1.00419L0.836825 0L4.66669 3.19155V4.34845L0.836825 7.54L0 6.53581L3.31897 3.77Z"
        fill="currentColor"
      />
    </svg>
  );
};
